/**
 * Generates cart summary based on the provided order summary.
 * @param orderSummary The order summary object containing subtotal, shipping, tax, and discount.
 * @returns An array of objects representing cart summary items.
 */
export const getCartSummary = (orderSummary: IOrderSummary) => {
  const { subtotal, shipping, tax, discount } = orderSummary;

  // Initialize an array to store summary items
  const cartSummary = [
    { label: "Subtotal:", value: `$${subtotal}` },
    { label: "Shipping:", value: `$${shipping}` },
    { label: "Tax:", value: `$${tax}` },
  ];

  // If discount exists, add it to the summary
  if (discount) {
    cartSummary.push({ label: "Discount:", value: `%${discount}` });
  }

  return cartSummary;
};
